import { useCanDebugMedia, useCanViewLiveCamera } from '@hakimo-ui/hakimo/util';
import { Toggle } from '@hakimo-ui/shared/ui-base';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import AudioRecorder from '../audio-recorder/AudioRecorder';

interface Props {
  cameraId: string | null;
  alarmId: string;
  debug: boolean;
  live: boolean;
  sharedToken?: string;
  onToggleDebug: (debug: boolean) => void;
  onToggleLive: (live: boolean) => void;
}

export function AlarmMediaActions(props: Props) {
  const {
    cameraId,
    alarmId,
    debug,
    live,
    sharedToken,
    onToggleDebug,
    onToggleLive,
  } = props;
  const canDebug = useCanDebugMedia();
  const canViewLive = useCanViewLiveCamera();
  const [showRecorder, setShowRecorder] = useState(false);

  return (
    <div className="mr-8 flex items-center gap-4">
      {!showRecorder && (
        <>
          {canDebug && !sharedToken && (
            <>
              <span className="dark:text-dark-text">Debug Mode</span>
              <Toggle
                enabled={debug}
                trackingInfo="debug"
                onChange={onToggleDebug}
                EnabledIcon={WrenchScrewdriverIcon}
                DisabledIcon={WrenchScrewdriverIcon}
              />
            </>
          )}
          {canViewLive && (
            <>
              {live && <span className="text-red-500">LIVE</span>}
              <Toggle
                enabled={live}
                trackingInfo="live"
                onChange={onToggleLive}
                EnabledIcon={EyeIcon}
                DisabledIcon={EyeSlashIcon}
              />
            </>
          )}
        </>
      )}
      {live && cameraId && (
        <AudioRecorder
          cameraId={cameraId}
          alarmId={alarmId}
          onToggle={setShowRecorder}
        />
      )}
    </div>
  );
}

export default AlarmMediaActions;
